// Need to use the React-specific entry point to allow generating React hooks
import { createApi } from '@reduxjs/toolkit/query/react'

import { baseQuery, getDefaultParams } from './queries'
import { Look } from '../../types/api-types'
import { store } from '../store/store'

// API used for the Look ressource
export const apiLook = createApi({
    baseQuery: baseQuery,
    endpoints: (builder) => ({
        getLook: builder.query<Look, Look>({
            query: (input) => {
                const state = store.getState()
                const storeConfig = state.config.config
                let fullUrl = '/look'
                if (storeConfig && storeConfig['api_prefix']) {
                    fullUrl =
                        (!storeConfig['api_prefix'].match(/^\//) ? '/' : '') +
                        storeConfig['api_prefix'] +
                        '/look'
                }

                // ---- Garment Types from config ----
                const garmentTypes = state.config.apiConfig?.garment_types

                // ---- Default Param for request ----
                const defaultConfig = getDefaultParams()

                // ---- Init payload ----
                const parsedLook: Look = defaultConfig ? defaultConfig : {}

                // ---- Ajout du use crop ----
                parsedLook.use_crop = true

                // ---- We build the payload from the look request ----
                for (const field in input) {
                    let parsedField = field
                    const parsedValue = input[field]

                    if (parsedValue) {
                        if (garmentTypes?.indexOf(field.toUpperCase()) !== -1) {
                            parsedField = `${field}_garment_id`
                            parsedLook[parsedField] = input[field].garment_id

                            continue
                        }

                        if (field === 'model') {
                            parsedField = `${field}_id`
                            parsedLook[parsedField] = input.model?.model_id

                            continue
                        }

                        if (
                            field === 'mode' ||
                            field === 'outerwear_garment_id' ||
                            field === 'multisizing'
                        ) {
                            parsedLook[parsedField] = parsedValue

                            continue
                        }
                    }
                }

                return {
                    url: fullUrl,
                    params: parsedLook || undefined,
                }
            },
        }),
    }),
    reducerPath: 'apiLook',
})

// Export hooks for usage in function components, which are
// auto-generated based on the defined endpoints
export const { useGetLookQuery } = apiLook
